/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var StackHDownIcon32Regular = forwardRef('StackHDownIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M11 2a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H11Z" }),
        React.createElement("path", { d: "M7 7a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 15a5 5 0 0 1 5-5h16a5 5 0 0 1 5 5v9a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5v-9Zm5-3a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3H8Z" })));
});
